import { OnInit, Component } from "@angular/core";
import { UserService } from "../services/user.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { fadeInUp } from '../services/animations/fadeInUp.animation'
import { CheckEmail } from '../services/validators/check-email.validator'
@Component({
	selector: 'app-search-user',
	templateUrl: './search-user.component.html',
	animations: [fadeInUp]
})
export class SearchUserComponent implements OnInit {

	searchUserForm: FormGroup
	users: any
	userIndex: number = -1
	deleteUserRequested: boolean = false
	errors: any = []
	messages: any = []
	searchErrors: any = []

	constructor(
		private userService: UserService,
		private fBuilder: FormBuilder) {}

	ngOnInit() {
		this.searchUserForm = this.fBuilder.group({
			'searchText': [null, Validators.compose([Validators.required, CheckEmail])],
		})
		this.searchUserForm.valueChanges.subscribe(val => {
			this.searchErrors = []
		})
	}

	searchUser() {
		this.messages = []
		this.searchErrors = []
		this.users = null
		if (this.searchUserForm.valid) {
			const payload = this.searchUserForm.value
			this.userService.searchUser(payload).then((res: any) => {
				this.users = [res]
			}).catch(err => {
				this.searchErrors = err
			})
		} else {
			this.searchErrors = [{ msg: 'Email is invalid' }]
		}
	}

	deleteUser(index: number) {
		this.userIndex = index
		this.deleteUserRequested = true
	}

	cancelDeleteUser() {
		this.userIndex = -1
		this.deleteUserRequested = false
		this.errors = []
	}

	confirmDeleteUser() {
		this.messages = []
		if (this.userIndex !== -1) {
			const user = this.users[this.userIndex]
			this.userService.deleteUser(user)
			.then((res: any) => {
				this.messages = res
				this.users = []
			}, error => {
				this.errors.push(error[0].msg)
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/admin/search-user.component.ts